define([
	"dojo/_base/declare",
	"csi/def",
	"csi/heading/Renderer",
	"csi/locale",
	"csi/resolver"
], function(declare,def,Renderer,locale,resolver) {

	return declare(Renderer, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: value is breadcrumb trail
			var	node = ctx.getNode();
			var	name, value;

			while (node) {
				name = def.canNavigateToType(node.$Type) ? locale.getNodeConfiguredName(node, ctx.cache) : null;
				if (name) value = name + (value ? " > " + value : "");
				node = resolver.resolveParent(node, null, true);
			}

			return value;
		}
	});
});